import { deleteBulkCollaboratorsData, ActionTypes } from 'store/data/collaborators';
import { Operation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';

type HandlerInput = Parameters<typeof deleteBulkCollaboratorsData>[0];

export function useDeleteBulkCollaboratorsData(): Operation<(input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(
		ActionTypes.DELETE_BULK_COLLABORATORS_DATA
	);

	function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(deleteBulkCollaboratorsData(input));
	}

	return [{ loading, error }, handler];
}
